var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9223 6.07757C14.2477 6.40301 14.2477 6.93065 13.9223 7.25609L8.72876 12.4496L12.3251 12.5002C12.7853 12.5067 13.1531 12.885 13.1467 13.3452C13.1402 13.8054 12.7619 14.1732 12.3017 14.1667L6.73304 14.0883C6.28199 14.082 5.91788 13.7179 5.91152 13.2668L5.83309 7.69817C5.82661 7.23798 6.19442 6.85967 6.65461 6.85319C7.1148 6.84671 7.49311 7.21451 7.49959 7.6747L7.55025 11.2711L12.7438 6.07757C13.0692 5.75214 13.5968 5.75214 13.9223 6.07757Z",
    fill: "#FF2845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownLeft);
export default __webpack_public_path__ + "static/media/ic-arrow-down-left.c3cdb83e4a2f390c3aa853dfd055c454.svg";
export { ForwardRef as ReactComponent };